<template>
  <div class="card py-2 px-3 mb-1">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div style="font-weight: 600">{{ category.name }}</div>
        <div>
          <span class="mr-2" style="text-transform: capitalize">
            Subject:
            {{ category.subject }}
          </span>
        </div>
      </div>
      <div v-if="deleted === false">
        <a
          @click="$_openCategoryModal(category._id)"
          href="#"
          style="font-weight: 600"
          >EDIT</a
        >
        <a
          @click="deleteCategory()"
          class="ml-3"
          href="#"
          style="font-weight: 600"
          >DELETE</a
        >
      </div>
      <div v-if="deleted === true">DELETED</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["category"],
  data() {
    return {
      deleted: false,
    };
  },
  methods: {
    deleteCategory() {
      this.axios
        .delete(
          `${process.env.VUE_APP_API_URL}/api/categorys/${this.category._id}`
        )
        .then((res) => {
          this.deleted = true;
          this.$root.$emit("popup", "Category successfully deleted.");
        });
    },
    editCategory() {},
  },
};
</script>
